<template>
    <div style="display:none;">
        <slot name="info-window"></slot>
    </div>
</template>

<script>
    import GoogleOverlay from '../utils/CustomGoogleOverlay'


  export default {
    name: "map-marker",
    props: ['position', 'map', 'icon', 'markerObject', 'actionBeforeDestroy', 'visibility', 'title'],
    data() {
      return {
        markerElement: null,
        infoWindowOverlay: null
      }
    },
    computed: {
      bounds() {
        return google? new google.maps.LatLngBounds(this.position) : null;
      },
      infoWindowElement() {
        if(! this.$slots['info-window']) return null;
        if(this.$slots['info-window'][0]) {
          let parent = this.$slots['info-window'][0].elm.parentElement;
          parent.removeChild(this.$slots['info-window'][0].elm);
        }
        return this.$slots['info-window']? this.$slots['info-window'][0].elm : null;
      }
    },
    watch: {
      map(newVal) {
        this.setMap(newVal)
        this.createInfoWindow();
        // this.infoWindowOverlay.setMap(newVal)
      },
      icon(newVal) {
        this.setIcon(newVal)
      },
      'markerElement.icon'(newVal) {
        this.$emit('update:icon', newVal)
      },
      visibility(val) {
        this.markerElement.setVisible(val)
      },

    },
    mounted() {
      if(this.markerObject) return;
      this.$googleApiPromise.then(google => {
        if(! window.markerTimer) {
          window.markerTimer = 0;
        }else {
          window.markerTimer += 200;
        }
        // Redukcja laga przy ładowaniu strony. Markery dodają się "asynchronicznie"
        // setTimeout(() => {
          this.markerElement = new google.maps.Marker({
            position: this.position,
            icon: this.icon,
            title: this.title || ''
          })

          this.createInfoWindow();
          this.forwardMarkerEvents();
          this.$emit('markerCreated', this.markerElement);
        // }, window.markerTimer);

      })
    },
    beforeDestroy() {
      if(this.actionBeforeDestroy == 'destroy')
        this.markerElement.setMap(null);
      else
        this.markerElement.setVisible(false)
    },
    methods: {
      createInfoWindow() {
        if(this.infoWindowElement) {
          // console.log(this.map.getProjection());
          // console.log(this.map.getProjection().fromLatLngToPoint(this.bounds.getNorthEast()))
          // this.$nextTick(() => {
            // console.log(this.bounds, this.infoWindowElement, this.map)
            this.infoWindowOverlay = new GoogleOverlay(this.bounds, this.infoWindowElement, this.map, {x: 0, y: -32});
          // })
        }
      },

      forwardMarkerEvents() {
        this.markerElement.addListener('mouseover', () => this.$emit('mouseover'))
        this.markerElement.addListener('mouseout', () => this.$emit('mouseout'))
        this.markerElement.addListener('click', () => this.$emit('click'))
      },

      setMap(map) {
        if(map.googleMap) map = map.googleMap;
        if(this.markerElement) this.markerElement.setMap(map)
      },

      setIcon(icon) {
        if(this.markerElement) this.markerElement.setIcon(icon)
      }
    }
  }
</script>

<style scoped>

</style>
